module.exports = __webpack_public_path__ + "img/oncology.31abe873.png";